let BASE_URL = "https://mf.neosurge.money/";
if (process.env.REACT_APP_ENVIRONMENT === "production") {
  BASE_URL = "https://mf.neosurge.money/";
}

let namespace = "";

export { BASE_URL, namespace };
